//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import APIS from "../../../constant/EndPoint";
import usePostHook from "../../../customHooks/usePostHook";
import { queryClient } from "../../../router/ReturnOrderRouter";
import Button from "../../Reusable/Button";
import ReturnChargeFrom from "./ReturnChargeFrom";
const ReturnChargeSetting = (props: any) => {
  const { openRTvSettingPopup, setOpenRTVSettingPopup, RtvChargeSetting } =
    props;
  const {
    register,
    setValue,
    getValues,
    setError,
    handleSubmit,
    watch,
    formState: { errors },
    clearErrors,
  } = useForm({
    //@ts-ignore
    // resolver: yupResolver(RTVChargeSettingValidationFrom),
    defaultValues: async () => {
      return {
        same_warehouse: {
          percentage: RtvChargeSetting?.same_warehouse?.percentage ?? "",
          amount: RtvChargeSetting?.same_warehouse?.amount ?? "",
          vendors: RtvChargeSetting?.same_warehouse?.vendors?.map(
            (item: any) => item?.id
          ),
        },
        different_warehouse: {
          percentage: RtvChargeSetting?.different_warehouse?.percentage ?? "",
          amount: RtvChargeSetting?.different_warehouse?.amount ?? "",
          vendors: RtvChargeSetting?.different_warehouse?.vendors?.map(
            (item: any) => item?.id
          ),
        },
      };
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["rtv-charge-setting"],
    navigateURL: "",
  });
  const handleChangeRTVSetting = async (values: any, setError: any) => {
    let formData = {
      ...values,
    };
    const url = `${APIS.RTV_CHARGE}`;
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        queryClient.refetchQueries();
        setOpenRTVSettingPopup(!openRTvSettingPopup);
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <form
        action=""
        onSubmit={handleSubmit((data: any) =>
          handleChangeRTVSetting(data, setError)
        )}
      >
        <div className={tw`grid grid-cols-2 gap-x-4  mt-4 `}>
          <ReturnChargeFrom
            label={"Same Warehouse"}
            register={register}
            name={"same_warehouse"}
            //@ts-ignore
            errors={errors?.same_warehouse}
            setValue={setValue}
            getValues={getValues}
            clearErrors={clearErrors}
            data={RtvChargeSetting?.same_warehouse}
            watch={watch}
          />

          <ReturnChargeFrom
            label={"Different Warehouse"}
            register={register}
            name={"different_warehouse"}
            //@ts-ignore
            errors={errors?.different_warehouse}
            setValue={setValue}
            getValues={getValues}
            data={RtvChargeSetting?.different_warehouse}
            clearErrors={clearErrors}
            watch={watch}
          />
        </div>
        <div className={tw`w-full flex justify-end mt-4 mr-2`}>
          <div className={tw`w-32`}>
            <Button label={"Submit"} isLoading={isPostLoading} />
          </div>
        </div>
      </form>
    </>
  );
};

export default ReturnChargeSetting;
